import {gql} from "@apollo/client";

export const UPDATE_BUSINESS_STARTER_TOOLKIT = gql`
  mutation createBusinessSTarterToolkit($input: BusinessStarterToolkitStatusInput!) {
    updateBusinessStarterToolkitApprovalStatus(input: $input){
        _id
        firstName
    }
}
`;